import classNames from 'classnames'
import React, { ReactNode } from 'react'

import styles from './CarouselItem.module.scss'

export interface CarouselChildProps {
  children: ReactNode
  className?: string
}

export const CarouselChild: React.FC<CarouselChildProps> = ({ children, className }) => (
  <div className={classNames(styles.carouselItem, className)}>{children}</div>
)
